import { Button } from '@/components/form/baseInputs/Button/Button';
import { Stars01Icon } from '@/components/icons/Stars01Icon';
import { SlideEditorToolbarDivider } from '@/modules/slideEditor/textEditors/SlideEditor.toolbarDivider';

interface EntityNotesToolbarButtonsProps {
  /** Opens the AI notes generation modal. Hidden when undefined. */
  onGenerateAI?: () => void;
  isGenerating: boolean;
  isSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * Toolbar buttons for the entity diagram notes editor. Rendered as
 * `endToolbarButtons` in the SlideEditorRichTextEditor toolbar.
 *
 * Layout: [Generate from AI] | [Cancel] [Save]
 */
export function EntityNotesToolbarButtons({
  onGenerateAI,
  isGenerating,
  isSaving,
  onSave,
  onCancel,
}: EntityNotesToolbarButtonsProps) {
  return (
    <>
      {onGenerateAI && (
        <>
          <SlideEditorToolbarDivider />
          <Button
            variant="transparent"
            size="xs"
            startIcon={Stars01Icon}
            onClick={onGenerateAI}
            loading={isGenerating}
            sx={{ borderRadius: '4px', px: 1, py: 0.5, whiteSpace: 'nowrap' }}
          >
            {isGenerating ? 'Generating...' : 'Generate with AI'}
          </Button>
        </>
      )}
      <SlideEditorToolbarDivider />
      <Button
        variant="secondary"
        size="xs"
        onClick={onCancel}
        sx={{ borderRadius: '4px', px: 1, py: 0.5 }}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        size="xs"
        onClick={onSave}
        loading={isSaving}
        sx={{ borderRadius: '4px', px: 1, py: 0.5, ml: 0.5 }}
      >
        Save
      </Button>
    </>
  );
}
